import { useCallback, useEffect, useLayoutEffect, useState } from 'react';

export default function usePortrait() {
  const [isPortrait, setIsPortrait] = useState<boolean>(false);

  const handleSize = useCallback(() => {
    setIsPortrait(window.innerHeight > window.innerWidth);
  }, []);

  useLayoutEffect(() => {
    handleSize();
  }, [handleSize]);

  useEffect(() => {
    window.addEventListener('resize', handleSize);
    return () => {
      window.removeEventListener('resize', handleSize);
    };
  }, [handleSize]);

  return isPortrait;
}
